import app from '@/lib/app';
import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';

interface BrandProps {
  collapsed?: boolean;
}

const Brand = ({ collapsed = false }: BrandProps) => {
  return (
    <div className={cn(
      "flex shrink-0 items-center relative z-10",
      collapsed ? "pt-5 pb-3" : "pt-5 pb-1",
      collapsed ? "justify-center" : "pl-2"
    )}>
      <Link to="/home" className="block transition-all duration-200 hover:opacity-80">
        <img
          className={cn(
            collapsed ? "h-7 w-7" : "h-8 w-auto"
          )}
          src={collapsed ? "/logo-icon.svg" : app.logoUrlOnDark}
          alt={app.name}
          width={collapsed ? 28 : 130}
          height={collapsed ? 28 : 32}
        />
      </Link>
    </div>
  );
};

export default Brand;
